import { render, staticRenderFns } from "./HCMain.vue?vue&type=template&id=3cd5db60&"
import script from "./HCMain.vue?vue&type=script&lang=js&"
export * from "./HCMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports